import { render } from "./CardAttachmentMediaDialog.vue?vue&type=template&id=6fb5dabc&scoped=true"
import script from "./CardAttachmentMediaDialog.vue?vue&type=script&lang=js"
export * from "./CardAttachmentMediaDialog.vue?vue&type=script&lang=js"

import "./CardAttachmentMediaDialog.vue?vue&type=style&index=0&id=6fb5dabc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb5dabc"]])

export default __exports__